<template>
  <div class="left-chart-3" id="left-chart-3"></div>
</template>

<script>
import { querysbyjsypmtop } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart3',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const echartsDom = document.getElementById('left-chart-3')
      this.chart = this.$echarts.init(echartsDom)
      const apiData = await querysbyjsypmtop(this.date)
      let yDatas = []
      let chartbDatas = []
      apiData.forEach(item => {
        yDatas.push(item.org_name || '')
        chartbDatas.push(item.between_sbsy || 0)
      })
      const options = {
        title: {
          text: '设备月均收益排名列表',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: 'value',
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            color: '#fff',
          },
          data: yDatas,
        },
        series: [
          {
            name: '收益（元）',
            type: 'bar',
            data: chartbDatas,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-3 {
  width: 100%;
  height: 33%;
  display: flex;
  flex-direction: column;
}
</style>
